import type {
  SurgeryPipelineRow,
  SurgeryProcedureRow,
  SurgeryQuickKpiTotals,
  SurgerySurgeonRow,
  SurgeryWaitBucket,
} from '../types';

/** Stacked bar for planned / completed / cancelled in the selected period (quick tier). */
export function surgeryPeriodActivityChartFromQuickKpis(
  totals: SurgeryQuickKpiTotals | undefined,
  periodLabel: string,
) {
  if (!totals) {
    return { series: [], categories: [], count: 0 };
  }
  return {
    series: [
      { name: 'planned', data: [totals.planned] },
      { name: 'completed', data: [totals.completed] },
      { name: 'cancelled', data: [totals.cancelled] },
    ],
    categories: [periodLabel],
    count: totals.planned + totals.completed + totals.cancelled,
  };
}

export function surgeryTopProceduresChart(rows: SurgeryProcedureRow[] | undefined, limit = 10) {
  if (!rows?.length) {
    return { series: [], categories: [], count: 0 };
  }
  const sorted = [...rows].sort((a, b) => b.episodeCount - a.episodeCount).slice(0, limit);
  return {
    series: [{ name: 'episodes', data: sorted.map((row) => row.episodeCount) }],
    categories: sorted.map((row) => row.procedureLabel),
    count: sorted.reduce((sum, row) => sum + row.episodeCount, 0),
  };
}

export function surgeryWaitDistributionChart(buckets: SurgeryWaitBucket[] | undefined) {
  if (!buckets?.length) {
    return { series: [], categories: [], count: 0 };
  }
  return {
    series: [{ name: 'completed', data: buckets.map((b) => b.count) }],
    categories: buckets.map((b) => b.label),
    count: buckets.reduce((sum, b) => sum + b.count, 0),
  };
}

export function surgeryPipelineChart(rows: SurgeryPipelineRow[] | undefined) {
  if (!rows?.length) {
    return { series: [], categories: [], count: 0 };
  }
  return {
    series: [{ name: 'requests', data: rows.map((row) => row.count) }],
    categories: rows.map((row) => String(row.status)),
    count: rows.reduce((sum, row) => sum + row.count, 0),
    pipelineRows: rows,
  };
}

export function surgeryProcedureTableRows(rows: SurgeryProcedureRow[] | undefined) {
  return rows ?? [];
}

export function surgerySurgeonTableRows(rows: SurgerySurgeonRow[] | undefined) {
  return rows ?? [];
}
